import { errorValidation } from "./error";

import {
  validLength,
  validText,
  validNumber,
  validPhoneNumber,
  validAlphaNumeric,
  validPiva,
  validIban,
  validCodiceFiscale,
  validDate,
  validURL,
  validZipCode,
  validEmail,
  validPsw,
  validSameValue,
  validCodiceRichiesta,
  validAddress,
  validUpload,
  validMultipleNumber,
} from "./regex";

// formValidation gets the event as params
// According to the data-validate prop of the component, the errorValidation function will be set
// erroValidtion returns true or false

export const formValidation = (event, length) => {
  const target = event.target;
  const value = event.target.value;

  const dataValidate = event.target.getAttribute("data-validate");

  switch (dataValidate) {
    case "notEmpty":
      return errorValidation(validLength(value), target);

    case "isText":
      return errorValidation(validText(value), target);

    case "isNumber":
      return errorValidation(validNumber(value), target);

    case "isPhoneNumber":
      return errorValidation(validPhoneNumber(value), target);

    case "isAlphaNumeric":
      return errorValidation(validAlphaNumeric(value), target);

    case "isPiva":
      return errorValidation(validPiva(value), target);

    case "isIban":
      return errorValidation(validIban(value), target);

    case "isCodFiscale":
      return errorValidation(validCodiceFiscale(value), target);

    case "isDate":
      return errorValidation(validDate(value), target);

    case "isURL":
      return errorValidation(validURL(value), target);

    case "isZIP":
      return errorValidation(validZipCode(value), target);

    case "isEmail":
      return errorValidation(validEmail(value), target);

    case "isPsw":
      return errorValidation(validPsw(value), target);

    case "isSameValue":
      return errorValidation(validSameValue(value), target);

    case "isSelected":
      return errorValidation(validLength(value), target);

    case "isRadioChecked":
      // could be used just the value from: event.target.checked? If yes, then there is no need to ude a regex for that
      return errorValidation(target.checked, target);

    case "isChecked":
      return errorValidation(value.checked, target);

    case "isUpload":
      return errorValidation(validUpload(event), target);

    case "isCodRichiesta":
      return errorValidation(validCodiceRichiesta(value), target);

    case "isIndirizzo":
      return errorValidation(validAddress(value), target);

    case "isMultipleNumber":
      return errorValidation(validMultipleNumber(value, length), target);

    case "null":
      break;

    default:
  }
};
